import { SocialWebStreamWidget } from 'schemas/SocialWebStreamWidgetSchema'
import { AudienceStreamWidget } from 'schemas/AudienceStreamWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import CountType, { CountTypeStrings } from 'enums/CountType'
import ServiceType from 'enums/ServiceType'
import { toFilter } from 'utils/widgetUtil'
import { createFingerprintRetrieval } from 'utils/runSearchUtil'

// Bound the document-list fingerprint pull for the Stream widget (POSTS mode). This spec
// is the in-browser scroll cursor — all matching doc IDs are fetched once, then paged
// client-side — so an unbounded pull made Prospero scan the entire matching set (e.g.
// ~54K docs -> 34-44s RetrieveFields op -> runSearches broken-pipe timeouts). 2000
// most-recent unique docs is ample for the list. Mirrors the v3 CB3 change in
// app-cb-closure run_search.js (createDocumentFingerprintRetrieval).
const STREAM_DOCUMENT_FINGERPRINT_SIZE = 2000

const createFingerprintSearch = (
  widgetSetting: SocialWebStreamWidget | AudienceStreamWidget,
  dashboardData: Dashboard,
  countType: CountTypeStrings
) => {
  const { sort, selectedTopic } = widgetSetting
  const { id: dashboardId, name } = dashboardData
  const filter = toFilter(widgetSetting)

  return createFingerprintRetrieval(
    countType === CountType.POSTS
      ? ServiceType.DOCUMENT_FINGERPRINT_RETRIEVAL
      : ServiceType.SENTENCE_FINGERPRINT_RETRIEVAL,
    dashboardId!,
    name!,
    [selectedTopic.topicId!],
    filter,
    widgetSetting.precision!,
    sort!,
    countType === CountType.POSTS ? STREAM_DOCUMENT_FINGERPRINT_SIZE : undefined
  )
}

export default createFingerprintSearch
